export default "__VITE_PUBLIC_ASSET__f5a26404__"